// 外汇、人民币中间价涨跌幅详情
import { Observer } from "mobx-react-lite"
import React from "react"
import { PageType } from "../../shared/pagetype"
import { single_quote, quote_item_name, quote_chart } from "../../shared/quotedata/index"
import { ChartType } from "../../shared/utils"

export function ForexZDFDetails(props:{detail_data:any, chart_mouse_move_data:any, chartType:ChartType,pagetype:PageType}) {
  return (
    <Observer>
      {() => (
        <ul className="forex-zdf-details">
          <li>
            <span>点差</span>
            {props.pagetype == PageType.人民币中间价 ? single_quote[quote_item_name.点差](props.detail_data).cny_element:single_quote[quote_item_name.点差](props.detail_data).element}
          </li>
          <li>
            <span>10日</span>
            {single_quote[quote_item_name["10日涨跌幅"]](props.detail_data).element}
          </li>
          <li>
            <span>60日</span>
            {single_quote[quote_item_name["60日涨跌幅"]](props.detail_data).element}
          </li>
          {props.chart_mouse_move_data && props.chartType != ChartType.分时 ? (
            <li>
              <span>振幅</span>
              {quote_chart[quote_item_name.振幅](props.chart_mouse_move_data.amplitude).element}
            </li>
          ) : (
            <li>
              <span>振幅</span>
              {single_quote[quote_item_name.振幅](props.detail_data).element}
            </li>
          )}
          <li>
            <span>20日</span>
            {single_quote[quote_item_name["20日涨跌幅"]](props.detail_data).element}
          </li>
          <li>
            <span>今年来</span>
            {single_quote[quote_item_name.今年来涨跌幅](props.detail_data).element}
          </li>
        </ul>
      )}
    </Observer>
  )
}
